const SESSION_KEY = "property-pal-session-id";
const SESSION_EXPIRY_KEY = "property-pal-session-expiry";
const SESSION_DURATION_MS = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

export function getSessionId(): string | null {
  const sessionId = localStorage.getItem(SESSION_KEY);
  const expiry = localStorage.getItem(SESSION_EXPIRY_KEY);

  // check if there is a session id or if session has expired
  if (!sessionId || (expiry && Number(expiry) < Date.now())) {
    clearSession();
    return null;
  }
  addSessionExpiry(); // update session expiry on every interaction
  return sessionId;
}

// add new session id and set expiry time
export function setSessionId(id: string): void {
  localStorage.setItem(SESSION_KEY, id);
  addSessionExpiry();
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(SESSION_EXPIRY_KEY);
}

export function addSessionExpiry(): void {
  const newExpiry = (Date.now() + SESSION_DURATION_MS).toString();
  localStorage.setItem(SESSION_EXPIRY_KEY, newExpiry);
}
